import { render } from "./OrganizationSecurity.vue?vue&type=template&id=61c1bd55"
import script from "./OrganizationSecurity.vue?vue&type=script&lang=js"
export * from "./OrganizationSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__